export const ElementTypes = {
    Column: 1,
    Row: 2,
}
